import { RoutesInterface } from '@navigation/authRoutes';
import CircleIcon from '@mui/icons-material/Circle';
import InventoryScreen from '@screens/Cedis/Inventory/InventoryScreen';
import MyProfileScreen from '@screens/MyProfile/MyProfileScreen';
import InventoryAddInputs from '@screens/Cedis/Inventory/InventoryAddInputs';
import InventoryRemoveInputs from '@screens/Cedis/Inventory/InventoryRemoveInputs';
import InventoryPOS from '@screens/BranchOffices/Inventory/InventoryPOS';
import InventoryHistoryDetails from '@screens/Cedis/Inventory/InventoryInputDetails';
import ListInventoryOrdersScreen from '@screens/Cedis/Inventory/ListInventoryOrdersScreen';
import { ListAlt } from '@mui/icons-material';

const distributionCenterRoutes: RoutesInterface[] = [
    {
        path: 'myProfile',
        name: 'Mi Perfil',
        element: MyProfileScreen
    },
    {
        path: 'home',
        name: 'Inventario',
        element: InventoryScreen,
        icon: CircleIcon
    },
    {
        path: 'home/addInputs',
        name: 'Registrar entradas',
        element: InventoryAddInputs
    },
    {
        // Faltaba: `InventoryScreen` ofrece "Registrar salidas" a todos, pero
        // solo el admin tenía la ruta — para el CEDIS el botón no hacía nada
        path: 'home/removeInputs',
        name: 'Registrar salidas',
        element: InventoryRemoveInputs
    },
    {
        path: 'home/inventoryHistoryDetails',
        name: 'Detalles del movimiento',
        element: InventoryHistoryDetails
    },
    {
        path: 'orders',
        name: 'Pedidos',
        element: ListInventoryOrdersScreen,
        icon: ListAlt
    },
    {
        path: 'orders/details',
        name: 'Detalles del pedido',
        element: InventoryPOS
    }
];
export default distributionCenterRoutes;
